var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_497",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_498",
    "data-name": "Ellipse 498",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#f2f2f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5411",
    "data-name": "Group 5411",
    transform: "translate(-917 -647)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 917, 647)",
    filter: "url(#Ellipse_497)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_497-2",
    "data-name": "Ellipse 497",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(12 9)",
    fill: "#003e7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(939.309 667.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set-Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "print",
    d: "M122.549,221.384a1.37,1.37,0,0,1-1.37,1.37h-1.37a2.848,2.848,0,0,0-2.74-2.055h-8.22a2.848,2.848,0,0,0-2.74,2.055h-1.37a1.37,1.37,0,0,1-1.37-1.37v-1.37a1.37,1.37,0,0,1,1.37-1.37h16.439a1.37,1.37,0,0,1,1.37,1.37v1.37Zm-1.37-4.11H104.74a2.74,2.74,0,0,0-2.74,2.74v1.37a2.74,2.74,0,0,0,2.74,2.74h1.37a2.848,2.848,0,0,0,2.74,2.055h8.22a2.848,2.848,0,0,0,2.74-2.055h1.37a2.74,2.74,0,0,0,2.74-2.74v-1.37a2.74,2.74,0,0,0-2.74-2.74Zm-1.37-7.535a2.74,2.74,0,0,0-2.74-2.74h-8.22a2.74,2.74,0,0,0-2.74,2.74V215.9h13.7V209.74Z",
    transform: "translate(-102 -207)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.ce0632f0b5b6baff663d10c8ad3fba47.svg";
export { ForwardRef as ReactComponent };